import axios from './BaseService';

const USERS_URL = `${process.env.REACT_APP_API_URL}/users/`;

export async function getActiveUsers() {
    
    const response = await axios.get(`${USERS_URL}active`);
    return response.data;
}

export async function getUsers(search, page) {
    const usersUrl = `${USERS_URL}${search ? search : ''}?page=${page}`;

    
    const response = await axios.get(usersUrl);
    return response.data;//{count, rows}
}

export async function getUserOverview(id) {
    const response = await axios.get(`${USERS_URL}${id}/overview`);
    return response.data;
}

export async function updateUserWallet(id, patch) {
    const response = await axios.patch(`${USERS_URL}${id}/wallet`, patch);
    return response.data;
}

export async function depositUserWallet(id, amount) {
    const response = await axios.post(`${USERS_URL}${id}/deposit`, { amount });
    return response.data;
}

export async function updateUserPnl(id, pnl) {
    const response = await axios.patch(`${USERS_URL}${id}/pnl`, { pnl });
    return response.data;
}

export async function updateUserDeposited(id, amount) {
    const response = await axios.patch(`${USERS_URL}${id}/deposited`, { amount });
    return response.data;
}

export async function saveUser(id, newUser) {
    
    let response;
    if (id)
        response = await axios.patch(`${USERS_URL}${id}`, newUser);
    else
        response = await axios.post(USERS_URL, newUser);
    return response.data;
}

export async function deleteUser(id) {
    
    const response = await axios.delete(`${USERS_URL}${id}`);
    return response.data;
}

export async function startUser(id) {
    
    const response = await axios.post(`${USERS_URL}${id}/start`, {});
    return response.data;
}

export async function stopUser(id) {
    
    const response = await axios.post(`${USERS_URL}${id}/stop`, {});
    return response.data;
}

export async function getPredadorStatus() {
    const response = await axios.get(`${USERS_URL}predador-status`);
    return response.data;
}

export async function encerrarDolarizar() {
    const response = await axios.post(`${USERS_URL}encerrar-dolarizar`, {});
    return response.data;
}

export async function getAssetsBoard() {
    const response = await axios.get(`${USERS_URL}assets-board`);
    return response.data;
}

export async function encerrarDolarizarUser(id) {
    const response = await axios.post(`${USERS_URL}${id}/encerrar-dolarizar`, {});
    return response.data;
}

export async function encerrarPosicoes() {
    const response = await axios.post(`${USERS_URL}encerrar-posicoes`, {});
    return response.data;
}

export async function encerrarPosicoesUser(id) {
    const response = await axios.post(`${USERS_URL}${id}/encerrar-posicoes`, {});
    return response.data;
}

export async function retomarPredadorUser(id, huntMode) {
    const response = await axios.post(`${USERS_URL}${id}/retomar-predador`, { huntMode });
    return response.data;
}

export async function retomarPredador(huntMode) {
    const response = await axios.post(`${USERS_URL}retomar-predador`, huntMode ? { huntMode } : {});
    return response.data;
}

export async function markFundPaid(id) {
    const response = await axios.post(`${USERS_URL}${id}/fund/paid`, {});
    return response.data;
}

export async function resetUserPassword(id) {
    
    const response = await axios.post(`${USERS_URL}${id}/reset`, {});
    return response.data;
}